import { Button, Typography } from '@/ui';

import type { FC } from 'react';

interface MomentsInsightsBannerProps {
  memberFirstName: string;
  momentsUrl: string;
}

/**
 * Promotional banner for Moments AI insights, displayed on member profile pages.
 * Links coaches to the Moments tool for AI-powered session preparation and feedback.
 */
const MomentsInsightsBanner: FC<MomentsInsightsBannerProps> = ({
  memberFirstName,
  momentsUrl,
}) => (
  <div className="relative overflow-hidden rounded-xl bg-sage-500 shadow-md">
    {/* Dark blob overlay on left side */}
    <div
      className="pointer-events-none absolute inset-y-0 left-0 w-2/5"
      style={{
        background:
          'radial-gradient(ellipse 120% 200% at 0% 50%, rgba(0,0,0,0.35) 0%, transparent 70%)',
      }}
    />

    {/* Content container */}
    <div className="relative flex flex-col items-start gap-4 p-5 md:flex-row md:items-center md:justify-between md:gap-6 md:px-8 md:py-6">
      {/* Headline - left side */}
      <div className="z-10 shrink-0 md:w-1/4">
        <Typography className="font-bold leading-tight text-white" variant="h5">
          Better Coaching with
          <br />
          Less Admin Work
        </Typography>
      </div>

      {/* Description - center */}
      <div className="flex-1 md:px-4">
        <Typography className="text-sm text-white/90" variant="body2">
          Try our new tool that uses AI to help coaches prepare and get feedback
          on their sessions in just a few seconds.
        </Typography>
      </div>

      {/* CTA Button - right side */}
      <div className="flex flex-1 items-end justify-end">
        <a className="block" href={momentsUrl} rel="noreferrer" target="_blank">
          <Button
            className="whitespace-nowrap bg-bloom-200 text-cement-500 hover:bg-bloom-300"
            size="large"
            variant="contained"
          >
            Get Insights for {memberFirstName}
          </Button>
        </a>
      </div>
    </div>
  </div>
);

export default MomentsInsightsBanner;
